import './App.css';
import Router from './Router';
import dotenv from 'react-dotenv';
import { setIAAM } from './reducer/iaamSlice';
import { useDispatch } from 'react-redux';
import { setProfile } from './reducer/profileSlice';

import { LicenseInfo } from '@mui/x-license-pro';
import { ThemeProvider, createTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// console.log(dotenv.MUI_KEY);
LicenseInfo.setLicenseKey("36044210ae9cef4f06025a297fc3cd1bTz0xMjY0ODIsRT0xODA0MjkxMTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y");


const mdTheme = createTheme({
    typography: {
        fontFamily: 'Noto Sans Thai'
    },
    components: {
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    "& .MuiFormControlLabel-label": {
                        fontSize: '14px'
                    }
                }
            }
        }
    }
});

function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const navigate = useNavigate();
    // const [errorInitLogin, setErrorInitLogin] = useState(false);

    // useEffect(() => {
        
    //     // console.log("Test");
    // }, [])

    const getApps = async (inum) => {
        let options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json', 
                // 'Authorization': `bearer ${access_token}`
            }
        }
        const data = await fetch(`${dotenv.IAAM_HOST}/iaam-api/applications?inum=${inum}&app_type=WEB`, options);
        const json = await data.json()
        let apps = json.filter((item) => {return item.client_name !== dotenv.CLIENT_NAME? true : false})
        return apps.map((item) => {return {...item, client_name:item.client_name.split("-").join(" ")}})
    }

    const initLogin = async () => {
        // console.log(dotenv);
        
        const iaam = window.iaam;
        // console.log("Start Init");
        const resultInit = await iaam.initLoginFlow({
            op_host: dotenv.IAAM_GATEWAY_HOST,
            iaamgw_host: dotenv.IAAM_GATEWAY_HOST,
            client_id: dotenv.IAAM_CLIENT_ID,
            post_logout_uri: dotenv.POST_LOGOUT_URL,
            policyEnforcement: {
                aa_host: dotenv.TRB_AA_HOST,
                client_name: dotenv.CLIENT_NAME
            }
        })
        // console.log(`Init ${resultInit}`);
        if (resultInit) {
            let isLogin = await iaam.isLoggedIn();
            if (!isLogin) {
                // console.log(`App Loging`);
                iaam.login();
            } else {
                const policyEnforcement = await iaam.policyEnforcement();
                if (policyEnforcement.decision === "Permit") {
                    iaam.getProfile(async (err, profile) => {  
                        if(!err){
                            let apps = await getApps(profile.inum);
                            const response = await fetch(`${dotenv.MASTER_API_URL}/dpc/get_dpc_with_prov_code?prov_code=${profile?.province_code}`);
                            const data = await response.json();
                            profile["health_region_code"] = data.health_region_code;
                            profile["apps"] = apps
                            dispatch(setProfile(profile));
                        }
                        else{
                            iaam.login()
                        }
                    })
                } else {
                    const pathname = window.location.pathname;
                    if (pathname !== "/permission") {
                        navigate("/permission");
                    }
                }
            }
            dispatch(setIAAM(iaam))
        }
        
    }
    initLogin();

    // if (!permit) {
    //     return <></>;
    // }

    return (
        <ThemeProvider theme={mdTheme}>
            <div className="App" >
                <Router />
            </div>
        </ThemeProvider>
    );
}

export default App;